/* eslint-disable camelcase */
import { SerializedMeterModel } from '@enmon/commons/lib/tools';
import { captureException } from '@sentry/react';
import { useQuery, UseQueryOptions } from 'react-query';
import { useServices } from 'services/useServices';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useMeterModel = (
  id?: SerializedMeterModel['id'] | null,
  options: UseQueryOptions<SerializedMeterModel | null> = {},
) => {
  const {
    api: { meterModelsApiClient },
  } = useServices();

  return useQuery<SerializedMeterModel | null>({
    queryKey: QUERY_KEYS.meterModels.one(id),
    queryFn: async ({ signal }) => {
      if (!id) {
        return null;
      }

      const meterModel = await meterModelsApiClient.getOne(id, signal);

      return meterModel;
    },
    onError: (err: unknown) => {
      console.error(err);
      captureException(err);
    },
    enabled: Boolean(id),
    ...options,
  });
};
